// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".no-selected-msg[data-v-1bf93492]{color:#999}", "",{"version":3,"sources":["webpack://./resources/assets/js/components/app/batch/jobs/bank-deposit-request/main.vue"],"names":[],"mappings":"AAEA,kCACI,UADJ","sourcesContent":["\r\n\r\n.no-selected-msg {\r\n    color: #999;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
